import { useCallback, useMemo } from 'react';
import type { ConsistencyLink } from '@view-model/domain/ConsistencyLink';
import type { ViewCollectionContents } from '@view-model/domain/view/ViewCollectionContents';
import { classNames } from '@framework/utils';

export const CONSISTENCY_LINK_LINE_WIDTH = 32;
const CONSISTENCY_LINK_TRANSPARENT_LINE_WIDTH = 96;

type Props = {
  consistencyLink: ConsistencyLink;
  isSelected: boolean;
  onSelectConsistencyLink(id: string | null): void;
  viewContents: ViewCollectionContents;
};

export const ConsistencyLinkView: React.FC<Props> = ({
  consistencyLink,
  isSelected,
  onSelectConsistencyLink,
  viewContents,
}: Props) => {
  const sourcePosition = useMemo(() => {
    return viewContents.getCenterPoint(consistencyLink.from.id);
  }, [viewContents, consistencyLink.from]);
  const targetPosition = useMemo(() => {
    return viewContents.getCenterPoint(consistencyLink.to.id);
  }, [viewContents, consistencyLink.to.id]);

  const handleClick = useCallback(() => {
    if (isSelected) {
      onSelectConsistencyLink(null);
    } else {
      onSelectConsistencyLink(consistencyLink.id);
    }
  }, [consistencyLink.id, isSelected, onSelectConsistencyLink]);

  return (
    <>
      {sourcePosition && targetPosition && (
        <g onClick={handleClick}>
          <line
            strokeWidth={CONSISTENCY_LINK_TRANSPARENT_LINE_WIDTH}
            visibility="hidden"
            x1={sourcePosition.x}
            y1={sourcePosition.y}
            x2={targetPosition.x}
            y2={targetPosition.y}
            pointerEvents="stroke"
            cursor="pointer"
          />
          <line
            className={classNames(isSelected ? 'stroke-brand' : 'stroke-[#aaaaaa]', 'hover:stroke-brand-dark')}
            strokeWidth={CONSISTENCY_LINK_LINE_WIDTH}
            x1={sourcePosition.x}
            y1={sourcePosition.y}
            x2={targetPosition.x}
            y2={targetPosition.y}
            pointerEvents="stroke"
            cursor="pointer"
          />
        </g>
      )}
    </>
  );
};
